module.exports = "<div class=\"container\">\r\n    <img src=\"./assets/img/success.svg\">\r\n    <span>{{'success' | translate}}</span>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Users/jenkins/AppData/Local/Jenkins/.jenkins/workspace/keno-web/vit-keno/src/app/betting/success/success.component.html
// module id = ../../../../../src/app/betting/success/success.component.html
// module chunks = 1